import React from 'react';
import { EmployeeTile } from './EmployeeTile';
import type { UserActivityItem } from '../../types/tracking';

interface EmployeeListProps {
  employees: UserActivityItem[];
  selectedIds: Set<string>;
  onSelect: (userId: string, multiSelect: boolean) => void;
}

export const EmployeeList: React.FC<EmployeeListProps> = ({
  employees,
  selectedIds,
  onSelect,
}) => {
  if (employees.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center p-8 text-center">
        <p className="text-sm text-rgf-gray-500">
          No activity found for selected filters
        </p>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto">
      {employees.map((emp, index) => (
        <EmployeeTile
          key={emp.user_id ?? index}
          activity={emp}
          isSelected={selectedIds.has(emp.user_id)}
          onClick={(e) => onSelect(emp.user_id, e.ctrlKey || e.metaKey)}
        />
      ))}
    </div>
  );
};
